export const API_URL = 'https://rpjhotels.com/web-backend';